var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M54 108C83.8234 108 108 83.8234 108 54C108 24.1766 83.8234 0 54 0C24.1766 0 0 24.1766 0 54C0 83.8234 24.1766 108 54 108ZM42.269 73.6738L77.4621 54.0001L42.269 34.3264V73.6738Z","fill":"#E94976"}));
}

PlayButton.defaultProps = {"width":"108","height":"108","viewBox":"0 0 108 108","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
